import { type ClientListItem, type ClientListItemServer, formatNumber } from '@metapic-apps/shared'

import { normalizeRevenueTiers } from '@/lib/adapters/common.adapter'

/** Server-side revenue shares are fractions, shown as a percentage of up to 2 decimals (0.1104 → "11.04%"). */
export const formatRevenueShare = (revenueShare: number): string =>
  `${formatNumber(revenueShare * 100, 'standard', 'decimal', 2)}%`

export const formatRevenueTierLabel = (tier: {
  name: string
  revenueShare: number | string
}): string => `${tier.name} - ${formatRevenueShare(Number(tier.revenueShare))}`

export const normalizeClientListItem = (data: ClientListItemServer): ClientListItem => ({
  name: data.name,
  id: data.id,
  revenueShare: formatRevenueShare(data.revenue_share),
  hasOwnPaymentSystem: data.has_own_payment_system,
  ...(data.revenue_tiers && {
    revenueTiers: normalizeRevenueTiers(data.revenue_tiers),
  }),
})
